import styled from "@emotion/styled";
import { CheckIcon } from "@smartsheet/lodestar-icons";
import { toggleTheme } from "./toggleTheme";
const left = {
  large: 2,
  medium: 1
};
export const ToggleOnIcon = styled(CheckIcon)`
    transition: opacity ${_ref => {
  let {
    themeMode
  } = _ref;
  return toggleTheme.motion.animation(themeMode);
}};
    opacity: ${_ref2 => {
  let {
    visible
  } = _ref2;
  return visible ? 1 : 0;
}};
    position: relative;
    left: ${_ref3 => {
  let {
    toggleSize
  } = _ref3;
  return left[toggleSize];
}}px;
`;
//# sourceMappingURL=ToggleOnIcon.js.map